import {Dialog, DialogTitle, dialogTitleClasses, styled} from '@mui/material'

export const StyledDialogTitle = styled(DialogTitle, {shouldForwardProp: (prop) => prop !== 'underlineTitle'})(
  ({theme, underlineTitle}) => ({
    [`&.${dialogTitleClasses.root}`]: {
      borderBottom: underlineTitle ? `1px solid ${theme.palette.grey[200]}` : 'none'
    }
  })
)

export const StyledDialog = styled(Dialog)(() => ({
  '&.MuiDialog-root': {
    zIndex: 1600
  }
}))
